import './input-with-icon.component.scss';

import { memo } from 'react';
import { useTranslation } from "react-i18next";

import Icon from '../Icon';

const InputWithIcon = props => {
  const { t } = useTranslation();

  const {
    id,
    type,
    name,
    value,
    min,
    max,
    minLength,
    maxLength,
    inputClassName,
    placeholder,
    autoComplete,
    htmlFor,
    style,
    isInvalid,
    isHide,
    disabled,
    dataBsToggleOnInput, // for toggling dropdown once clicking on input.
    dataBsAutoClose,
    alignEnd,
    dropdownMenuStyle,
    subContainerOnClick,
    iconPosition,
    iconTitle,
    iconClassName,
    onClick,
    onChange,
    onFocus,
    onBlur,
    iconOnClick,
    readOnly,
    children, // for displaying dropdown modal purpose.
    ...other
  } = props;

  const classNameList = {
    invalid: 'invalid',
    disabled: 'disabled',
  };

  const invalidClassName = !!isInvalid ? classNameList['invalid'] : '';
  const disabeldClassName = !!disabled ? classNameList['disabled'] : '';
  const iconPositionName = iconPosition === 'left' ? 'left' : 'right';
  const containerPositionClassName =
    iconPosition === 'left'
      ? 'input-with-icon-container-left'
      : 'input-with-icon-container-right';
  const currentValue = value === null || value === undefined ? '' : String(value).trimStart();
  const currentMin = min === null || value === undefined ? '' : min;
  const currentMax = max === null || value === undefined ? '' : max;
  const currentMinLength = minLength === null || value === undefined ? '' : minLength;
  const currentMaxLength = maxLength === null || value === undefined ? '' : maxLength;
  const currentDataBsToggleOnInput = dataBsToggleOnInput ? 'dropdown' : '';
  const alignEndClassName = !!alignEnd ? 'dropdown-menu-end' : 'dropdown-menu-start';

  return (
    <>
      {!isHide && (
        <div
          className={`input-with-icon-container input-container ${invalidClassName} ${disabeldClassName} ${containerPositionClassName}`}
          style={style}
        >

          {iconPositionName === 'left' && (
            <Icon
              iconTitle={t(iconTitle)}
              className={`icon-left ${iconClassName}`}
              onClick={iconOnClick}
            />
          )}

          <input
            id={id}
            type={type || 'text'}
            name={name}
            value={currentValue}
            min={currentMin}
            max={currentMax}
            minLength={currentMinLength}
            maxLength={currentMaxLength}
            data-bs-toggle={currentDataBsToggleOnInput}
            data-bs-auto-close={dataBsAutoClose}
            data-bs-display='static'
            readOnly={readOnly}
            className={inputClassName}
            placeholder={t(placeholder)}
            autoComplete={autoComplete}
            disabled={disabled}
            onClick={onClick}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            {...other}
          />

          {iconPositionName === 'right' && (
            <Icon
              iconTitle={t(iconTitle)}
              className={`icon-right ${iconClassName}`}
              onClick={iconOnClick}
            />
          )}

          {
            children &&
            <ul
              style={dropdownMenuStyle}
              className={`dropdown-menu dropdown-sub-container ${alignEndClassName}`}
              onClick={subContainerOnClick}
            >
              {children}
            </ul>
          }

        </div>
      )}
    </>
  );
};

export default memo(InputWithIcon);
